import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center justify-between gap-4 bg-white px-4 py-4 lg:px-8",
  "data-testid": "affiliate-header"
}
const _hoisted_2 = { class: "flex flex-col text-left" }
const _hoisted_3 = { class: "m-0 text-2xl font-bold text-textPrimary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2 text-[#7F7F8E]" }, "›", -1)
const _hoisted_5 = { "aria-current": "page" }
const _hoisted_6 = {
  key: 0,
  class: "mt-0.5 max-w-[80ch] text-sm text-[#163D45]",
  "data-testid": "affiliate-header-subtitle"
}
const _hoisted_7 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_8 = { class: "relative flex items-center" }
const _hoisted_9 = { class: "grid h-10 w-10 place-items-center rounded-full bg-primary font-bold text-white" }
const _hoisted_10 = {
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = {
  key: 0,
  class: "absolute right-0 top-12 z-10 w-48 rounded-xl border border-gray-200/80 bg-white py-1 shadow-md"
}

import { mdiChevronDown } from '@mdi/js'
import { ref } from 'vue'
import type { RouteLocationRaw } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateHeader',
  props: {
    title: {},
    subtitle: {},
    showBreadcrumb: { type: Boolean },
    homeLink: {},
    initials: {},
    canLogout: { type: Boolean }
  },
  emits: ["logout"],
  setup(__props: any, { emit }) {




const open = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        (_ctx.showBreadcrumb)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_router_link, {
                to: _ctx.homeLink,
                class: "hover:text-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Portal do Afiliado")
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ], 64))
      ]),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "actions"),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "flex items-center gap-1 text-primary",
          "data-testid": "affiliate-header-avatar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.initials), 1),
          (_openBlock(), _createElementBlock("svg", _hoisted_10, [
            _createElementVNode("path", { d: _unref(mdiChevronDown) }, null, 8, _hoisted_11)
          ]))
        ]),
        (open.value && _ctx.canLogout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "w-full px-4 py-3 text-left text-sm font-medium text-red-500 hover:bg-red-50",
                "data-testid": "affiliate-logout",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('logout')))
              }, " Sair ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})